<template>
  <v-container>
    <page-title
      icon="mdi-pencil-box-outline"
      sub="Páginas administrativas"
      home="/admin"
    />
    <v-card flat>
      <v-card>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="primary"
        >
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab class="mx-1 px-1 text-none">
            Usuários
          </v-tab>
          <v-tab class="mx-1 px-1 text-none">
            Grp menus do site
          </v-tab>
          <v-tab class="mx-1 px-1 text-none">
            Menus do site
          </v-tab>
          <v-tab class="mx-1 px-1 text-none">
            Grp menus do sistema
          </v-tab>
          <v-tab class="mx-1 px-1 text-none">
            Menus do sistema
          </v-tab>
        </v-tabs>
      </v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-row justify="space-around">
              <v-col
                cols="12"
                md="12"
              >
                <v-card flat>
                  <user-admin />
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-row justify="space-around">
              <v-col
                cols="12"
                md="12"
              >
                <v-card flat>
                  <grupo-menu-site />
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-row justify="space-around">
              <v-col
                cols="12"
                md="12"
              >
                <v-card flat>
                  <menu-site />
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-row justify="space-around">
              <v-col
                cols="12"
                md="12"
              >
                <v-card flat>
                  <grupo-menu-admin />
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-row justify="space-around">
              <v-col
                cols="12"
                md="12"
              >
                <v-card flat>
                  <menu-admin />
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '../../../components/template/PageTitle.vue'
import UserAdmin from '../components/UserAdmin.vue'
import MenuSite from '../components/MenuSite.vue'
import MenuAdmin from '../components/MenuAdmin.vue'
import GrupoMenuSite from '../components/GrupoMenuSite.vue'
import GrupoMenuAdmin from '../components/GrupoMenuAdmin.vue'
export default {
  components: { PageTitle, MenuSite, UserAdmin, MenuAdmin, GrupoMenuSite, GrupoMenuAdmin },
  name: 'AdminPages',
  data: () => ({
    tab: null
  })
}
</script>

<style>
</style>
